import React, { useState, useEffect, useRef } from 'react'
import { Toast } from "../services/Toast";
import Seo from '../components/Seo'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import Nav from '../components/products/Nav'
import Detail from '../components/products/Detail'
import NewSpec from '../components/products/NewSpec'
import NewFeatures from '../components/products/NewFeatures'
import SkuManager from '../components/products/create/SkuManager'
import { showAlert } from '../utils/showAlert'
const apiUrl = process.env.REACT_APP_API_URL;

export default function ProductCreateScreen({ match, history }) {

  const [dataChanged, setDataChanged] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [baselineReady, setBaselineReady] = useState(false);
  
  function dataChangeHandler() {
    setDataChanged(true);
  }

  const baselineRef = useRef(null);
  const pId = match.params.id
  const [path, setPath] = useState('');
  const editPath = '/admin/product/:id/edit';

  const dispatch = useDispatch();

  // loading
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  //for create product
  const [name, setName] = useState('');
  const [productId, setProductId] = useState('');
  const [groupId, setGroupId] = useState('');
  const [sku, setSKU] = useState('');
  const [category, setCategory] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [slug, setSlug] = useState('');
  const [media, setMedia] = useState([]);
  const [price, setPrice] = useState('');
  const [wasPrice, setWasPrice] = useState('');
  const [quantity, setQuantity] = useState('');
  const [hsn, setHsn] = useState('');
  const [weight, setWeight] = useState('');
  const [length, setLength] = useState('');
  const [breadth, setBreadth] = useState('');
  const [height, setHeight] = useState('');
  const [brandData, setBrandData] = useState('646cd8a00d1461aabc915564');
  const [brandName, setBrandName] = useState('');
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [features, setFeatures] = useState([]);
  const [x, setX] = useState('');
  const [optionsData, setOptionsData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState('')

  const [optionsDataNew, setOptionsDataNew] = useState([]);

  const categoryset = (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const hiddenValue = selectedOption.dataset.hiddenValue
    setCategory(event.target.value);
    setCategoryId(hiddenValue);
  }

  // seo
  const [seoData, setSeoData] = useState([])
  const [specifications, setSpecifications] = useState([])
  const [seo, setSeo] = useState({ pageTitle: '', metaDescription: '' })

  const [tax, setTax] = useState({taxTitle: '',taxState: '',taxRate: ''})
  
  const [pageTitle, setPageTitle] = useState(seo.pageTitle)
  const [metaDescription, setMetaDescription] = useState(seo.metaDescription)

  const [categoryNew, setCategoryNew] = useState('')
  const [selectedCategory, setSelectedCategory] = useState(
    '646c6a0485ed7c0dcc5fe68e'
  )

  const [tags, setTags] = useState([])

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setSeo({ ...seo, [name]: value })
  }
  const handleTaxChange = (event) => {
    const { name, value } = event.target;
    setTax((prevTax) => ({
      ...prevTax,
      [name]: value
    }));
  };


  //login info
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  // features
  const [allFeatures, setAllFeatures] = useState([])

  const [highlights, setHighlights] = useState([])
  const [warrantyTitle, setWarrantyTitle] = useState('')
  const [warrantyDescription, setWarrantyDescription] = useState('')
  const [freeGiftEnabled, setFreeGiftEnabled] = useState(false)
  const [freeGiftProductId, setFreeGiftProductId] = useState('')
  const [freeGiftQty, setFreeGiftQty] = useState(1)
  const [freeGiftQtyMode, setFreeGiftQtyMode] = useState('FIXED')
  const [freeGifts, setFreeGifts] = useState([])

  // SPU+SKU fields
  const [variantAxes, setVariantAxes] = useState([])
  const [skusData, setSkusData] = useState([])
  const [filterAttributes, setFilterAttributes] = useState([])

  // store data
  const data = {
    _id: pId,
    name: name,
    group_id: groupId,
    category: category,
    categoryId: selectedCategory,
    slug: slug,
    sku: sku,
    image: media,
    price: price,
    quantity: quantity,
    wasPrice: wasPrice,
    description: description,
    isActive: isActive,
    brandId: brandData,
    hsn: hsn,
    weight: weight,
    length: length,
    breadth: breadth,
    height: height,
    features: allFeatures,
    specifications: specifications,
    seo: seo,
    tags: tags,
    brand: brandName,
    highlights: highlights,
    warrantyTitle: warrantyTitle,
    warrantyDescription: warrantyDescription,
    tax: tax,
    free_gift_enabled: freeGiftEnabled,
    free_gift_product_id: freeGiftProductId || null,
    free_gift_qty: freeGiftQty,
    free_gift_qty_mode: freeGiftQtyMode,
    free_gifts: freeGifts,
    variantAxes: variantAxes,
    skus: skusData,
    filterAttributes: filterAttributes,
  }

  const normalizeComparable = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => normalizeComparable(item))
    }
    if (value && typeof value === 'object') {
      return Object.keys(value)
        .sort()
        .reduce((acc, key) => {
          acc[key] = normalizeComparable(value[key])
          return acc
        }, {})
    }
    return value ?? null
  }

  const buildComparableState = () =>
    normalizeComparable({
      name: name || '',
      groupId: groupId || '',
      category: category || '',
      categoryId: selectedCategory,
      slug: slug || '',
      sku: sku || '',
      image: media || [],
      price: price || '',
      wasPrice: wasPrice || '',
      quantity: quantity || '',
      hsn: hsn || '',
      weight: weight || '',
      length: length || '',
      breadth: breadth || '',
      height: height || '',
      description: description || '',
      isActive: isActive ?? true,
      brandId: brandData || '',
      features: allFeatures || [],
      specifications: specifications || [],
      seo: {
        pageTitle: seo?.pageTitle || '',
        metaDescription: seo?.metaDescription || '',
      },
      tags: tags || [],
      brand: brandName || '',
      highlights: highlights || [],
      warrantyTitle: warrantyTitle || '',
      warrantyDescription: warrantyDescription || '',
      tax: tax || { taxTitle: '', taxState: '', taxRate: '' },
      free_gift_enabled: freeGiftEnabled,
      free_gift_product_id: freeGiftProductId || null,
      free_gift_qty: freeGiftQty || 1,
      free_gift_qty_mode: freeGiftQtyMode || 'FIXED',
      // These are in the save payload but were never compared, so editing a SKU
      // (price / qty / images / isActive), a variant axis, a filter attribute or a
      // free-gift row left the form looking "clean" and SAVE stayed disabled.
      free_gifts: freeGifts || [],
      variantAxes: variantAxes || [],
      skus: skusData || [],
      filterAttributes: filterAttributes || [],
    })

  const buildComparableFromApi = (product) =>
    normalizeComparable({
      name: product?.name || '',
      groupId: product?.group_id || '',
      category: product?.category || '',
      categoryId: product?.categoryId || '',
      slug: product?.slug || '',
      sku: product?.sku || '',
      image: product?.image || [],
      price: product?.price || '',
      wasPrice: product?.wasPrice || '',
      quantity: product?.quantity || '',
      hsn: product?.hsn || '',
      weight: product?.weight || '',
      length: product?.length || '',
      breadth: product?.breadth || '',
      height: product?.height || '',
      description: product?.description || '',
      isActive: product?.isActive ?? true,
      brandId: product?.brandId || '',
      features: product?.features || [],
      specifications: product?.specifications || [],
      seo: product?.seo?.[0]
        ? {
            pageTitle: product.seo[0].pageTitle || '',
            metaDescription: product.seo[0].metaDescription || '',
          }
        : { pageTitle: '', metaDescription: '' },
      tags: product?.tags || [],
      brand: product?.brand || '',
      highlights: product?.highlights || [],
      warrantyTitle: product?.warrantyTitle || '',
      warrantyDescription: product?.warrantyDescription || '',
      tax: product?.tax || { taxTitle: '', taxState: '', taxRate: '' },
      free_gift_enabled: product?.free_gift_enabled ?? false,
      free_gift_product_id: product?.free_gift_product_id || null,
      free_gift_qty: product?.free_gift_qty ?? 1,
      free_gift_qty_mode: product?.free_gift_qty_mode || 'FIXED',
    })
  // image upload
  const [file, setFile] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])

  // upload media
  const [isUploadTriggered, setIsUploadTriggered] = useState(false);

  const uploadFileHandler = (e) => {
    e.preventDefault()
    const showMedia = document.getElementById('showMedia')
    const filenameList = Array.prototype.map.call(
      e.target.files,
      function (file) {
        return file.name
      }
    )
    showMedia.innerHTML += filenameList
    const formData = new FormData()
    formData.append('slug', slug);
    formData.append('productObjectId', productId);
    for (let i = 0; i < e.target.files.length; i++) {
      formData.append('image', e.target.files[i])
    }

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
      axios({
        method: 'post',
        config: config,
        data: formData,
        url: `${apiUrl}/api/upload`,
      }).then((res) => {
        let arr = res.data.split(',')
        media.push(...arr)
        updateProductData(true)
      })
    } catch (error) {}
  }


  // updates the product
  function updateProductData(isTrue) {
    setLoading(true);
    axios({
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      data: data,
      url: `${apiUrl}/api/products/edit/${pId}`,
    }).then((res) => {
      setLoading(false);
      Toast({ type: 'success', message: 'Product updated successfully!' });
      baselineRef.current = buildComparableState();
      setDataChanged(false);
      setBaselineReady(true);
      if (isTrue) {
        setIsUploadTriggered(true);
      }
    }).catch((error) => {
      // Without this the button stays on "Saving..." for ever: saveDisabled is
      // `loading || !dataChanged`, and only the success path cleared loading.
      setLoading(false);
      if (error.response) {
        showAlert(error.response.data.message,'danger');
      }
      else if (error.request) {
        showAlert('Error','danger');
      } else {
        console.error("Error:", error.message);
      }
    });
  }

  useEffect(() => {
    if (isUploadTriggered) {
      window.location.reload();
    }
  }, [isUploadTriggered]);

  

  // edit and create
  function submitHandler(e) {
    e.preventDefault();
  
    if (path === editPath) {
      updateProductData();
    } else {
      axios({
        method: 'post',
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
        data: data,
        url: `${apiUrl}/api/products`,
      })
      .then((res) => {
        // res
        const productId = res.data._id;
        history.push(`/admin/product/${productId}/edit`);
        Toast({ type: 'success', message: 'Product saved successfully!' });
      })
      .catch((error) => {
        if (error.response) {
          showAlert(error.response.data.message,'danger');
        }
        else if (error.request) {
          // The request was made but no response was received
          console.error("No response received from server:", error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error:", error.message);
        }
      });
    }
  }
  

  // gets product data
  async function getData() {
    try {
      let res = await axios({
        url: `${apiUrl}/api/products/edit/${pId}`,
        method: 'get',
        timeout: 8000,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (res.status == 200) {
        setName(res.data.name)
        setGroupId(res.data.group_id)
        setCategory(res.data.category)
        setCategoryId(res.data.categoryId)
        setSelectedCategory(res.data.categoryId)
        setSlug(res.data.slug)
        setSKU(res.data.sku)
        setMedia(res.data.image)
        setPrice(res.data.price)
        setWasPrice(res.data.wasPrice)
        setQuantity(res.data.quantity)
        setHsn(res.data.hsn)
        setWeight(res.data.weight)
        setLength(res.data.length)
        setBreadth(res.data.breadth)
        setHeight(res.data.height)
        setDescription(res.data.description)
        setIsActive(res.data.isActive)
        setBrandData(res.data.brandId)
        setSpecifications(res.data.specifications)
        setFeatures(res.data.features)
        setTags(res.data.tags)
        setOptionsData(res.data.optionsData)
        setCategoryNew(res.data.categoryId)
        setBrandName(res.data.brand)
        setProductId(res.data._id)
        setHighlights(res.data.highlights)
        setWarrantyTitle(res.data.warrantyTitle || '')
        setWarrantyDescription(res.data.warrantyDescription || '')
        setLastUpdated(res.data.updatedAt)
        setFreeGiftEnabled(res.data.free_gift_enabled ?? false)
        setFreeGiftProductId(res.data.free_gift_product_id || '')
        setFreeGiftQty(res.data.free_gift_qty ?? 1)
        setFreeGiftQtyMode(res.data.free_gift_qty_mode || 'FIXED')
        setFreeGifts(
          Array.isArray(res.data.free_gifts) && res.data.free_gifts.length > 0
            ? res.data.free_gifts.map((g) => ({
                product_id: g.product_id || g.productId || (g.product?._id) || '',
                qty: g.qty ?? 1,
                qty_mode: g.qty_mode || 'FIXED',
              }))
            : (res.data.free_gift_product_id
                ? [{
                    product_id: res.data.free_gift_product_id,
                    qty: res.data.free_gift_qty ?? 1,
                    qty_mode: res.data.free_gift_qty_mode || 'FIXED',
                  }]
                : [])
        )
        setVariantAxes(res.data.variantAxes || [])
        setSkusData(res.data.skus || [])
        setFilterAttributes(res.data.filterAttributes || [])

        // A product saved without SEO has no seo array at all, and every product
        // starts that way. Reading seo[0] threw; the catch below swallowed it into
        // the console, so setHasLoaded never ran - which left the baseline
        // uncaptured and SAVE disabled for good.
        const seoEntry = res.data.seo?.[0] || {}
        setSeo({
          pageTitle: seoEntry.pageTitle || '',
          metaDescription: seoEntry.metaDescription || '',
        })

        setPageTitle(seoEntry.pageTitle || '')
        setMetaDescription(seoEntry.metaDescription || '')
        setX(res.data.name)
        setTax(res.data.tax)
        setHasLoaded(true)
        setBaselineReady(false)
      }
      
      return res.data
    } catch (err) {
      // Without a baseline the SAVE button never enables, so a failure here
      // has to be visible and must still leave the screen usable.
      setHasLoaded(true)
      setBaselineReady(false)
      showAlert('Some of this product could not be loaded. Check it before saving.', 'warning')
      console.error(err)
    }
  }

  useEffect(() => {
    const header = document.getElementById('header')
    header.classList.remove('sticky-top')
    setPath(match.path)
    // Auto-generate group_id for new products
    if (match.path === '/admin/product/create' && !groupId) {
      setGroupId(crypto.randomUUID())
    }
    getData()
  }, [setSeoData, setSpecifications])

  useEffect(() => {
    if (baselineReady) return
    if (path === '/admin/product/create') {
      baselineRef.current = buildComparableState()
      setDataChanged(false)
      setBaselineReady(true)
      return
    }
    if (path === editPath && hasLoaded) {
      baselineRef.current = buildComparableState()
      setDataChanged(false)
      setBaselineReady(true)
    }
  }, [baselineReady, hasLoaded, path])

  // Warn before a reload / tab close / external navigation while edits are pending.
  // React Router navigation does not fire this, so the Go back link in Nav has its
  // own confirm. Browsers show their own wording and ignore custom text.
  useEffect(() => {
    if (!dataChanged) return
    const warnUnsaved = (e) => {
      e.preventDefault()
      e.returnValue = ''
      return ''
    }
    window.addEventListener('beforeunload', warnUnsaved)
    return () => window.removeEventListener('beforeunload', warnUnsaved)
  }, [dataChanged])

  useEffect(() => {
    if (!baselineReady || !baselineRef.current) return
    const current = buildComparableState()
    const isDirty =
      JSON.stringify(current) !== JSON.stringify(baselineRef.current)
    setDataChanged(isDirty)
  }, [
    name,
    groupId,
    category,
    selectedCategory,
    slug,
    sku,
    media,
    price,
    wasPrice,
    quantity,
    description,
    isActive,
    brandData,
    allFeatures,
    specifications,
    seo,
    tags,
    brandName,
    highlights,
    warrantyTitle,
    warrantyDescription,
    tax,
    // Previously missing: buildComparableState reads these, but without them here the
    // effect never re-ran, so changing any of them would NOT enable SAVE.
    hsn,
    weight,
    length,
    breadth,
    height,
    freeGiftEnabled,
    freeGiftProductId,
    freeGiftQty,
    freeGiftQtyMode,
    freeGifts,
    variantAxes,
    skusData,
    filterAttributes,
  ])

  const options = { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric', 
    hour: '2-digit', 
    minute: '2-digit', 
    second: '2-digit', 
    hour12: true, 
    timeZone: 'UTC' 
  };
  
  const formattedDate = new Date(lastUpdated).toLocaleString('en-GB', options);

  return (
    <>
      <style>{` .secondary-menu{display:none}`}</style>

      <form id='form'>
        <Nav
          slug={slug}
          submitHandler={submitHandler}
          loading={loading}
          error={error}
          errorMessage={errorMessage}
          dataChanged={dataChanged}
        />

        {
          path === '/admin/product/create' ? <></> :
          <div className='container'>
            <div className='row'>
              <p className='updated'>Updated on {formattedDate}</p>
            </div>
          </div>
        }



        <section>
          <div className='container'>
            <div className='accordion pdp__accordion' id='accordionPanelsStayOpenExample'>
              <div className='accordion-item'>
                <h2 className='accordion-header' id='panelsStayOpen-headingOne'>
                  <button
                    className='accordion-button collapsed'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#panelsStayOpen-collapseOne'
                    aria-expanded='true'
                    aria-controls='panelsStayOpen-collapseOne'
                  >
                    Product Details
                  </button>
                </h2>
                <div
                  id='panelsStayOpen-collapseOne'
                  className='accordion-collapse collapse show'
                  aria-labelledby='panelsStayOpen-headingOne'
                >
                  <div className='accordion-body'>
                    <Detail
                      productId={productId}
                      isEditMode={path === editPath}
                      setBrandName={setBrandName}
                      dataChangeHandler={dataChangeHandler}
                      groupId={groupId}
                      setGroupId={setGroupId}
                      pId={pId}
                      optionsDataNew={optionsDataNew}
                      setOptionsDataNew={setOptionsDataNew}
                      setSelectedCategory={setSelectedCategory}
                      selectedCategory={selectedCategory}
                      categoryNew={categoryNew}
                      setSKU={setSKU}
                      sku={sku}
                      submitHandler={submitHandler}
                      setOptionsData={setOptionsData}
                      optionsData={optionsData}
                      categoryset={categoryset}
                      categoryId={categoryId}
                      setCategoryId={setCategoryId}
                      tags={tags}
                      setTags={setTags}
                      pageTitle={pageTitle}
                      seoData={seoData}
                      metaDescription={metaDescription}
                      handleInputChange={handleInputChange}
                      handleTaxChange={handleTaxChange}
                      axios={axios}
                      setSlug={setSlug}
                      setCategory={setCategory}
                      category={category}
                      setName={setName}
                      setPrice={setPrice}
                      setWasPrice={setWasPrice}
                      setQuantity={setQuantity}
                      setHsn={setHsn}
                      setWeight={setWeight}
                      setLength={setLength}
                      setBreadth={setBreadth}
                      setHeight={setHeight}
                      setDescription={setDescription}
                      setIsActive={setIsActive}
                      isActive={isActive}
                      setBrandData={setBrandData}
                      brandData={brandData}
                      setFile={setFile}
                      setMedia={setMedia}
                      file={file}
                      uploadFileHandler={uploadFileHandler}
                      uploadedFiles={uploadedFiles}
                      Seo={Seo}
                      name={name}
                      slug={slug}
                      description={description}
                      price={price}
                      wasPrice={wasPrice}
                      quantity={quantity}
                      hsn={hsn}
                      weight={weight}
                      length={length}
                      breadth={breadth}
                      height={height}
                      media={media}
                      setSeo={setSeo}
                      seo={seo}
                      setHighlights={setHighlights}
                      highlights={highlights}
                      warrantyTitle={warrantyTitle}
                      setWarrantyTitle={setWarrantyTitle}
                      warrantyDescription={warrantyDescription}
                      setWarrantyDescription={setWarrantyDescription}
                      tax={tax}
                      freeGiftEnabled={freeGiftEnabled}
                      setFreeGiftEnabled={setFreeGiftEnabled}
                      freeGiftProductId={freeGiftProductId}
                      setFreeGiftProductId={setFreeGiftProductId}
                      freeGiftQty={freeGiftQty}
                      setFreeGiftQty={setFreeGiftQty}
                      freeGiftQtyMode={freeGiftQtyMode}
                      setFreeGiftQtyMode={setFreeGiftQtyMode}
                      freeGifts={freeGifts}
                      setFreeGifts={setFreeGifts}
                    />
                  </div>
                </div>
              </div>

              <div className='accordion-item'>
                <h2 className='accordion-header' id='panelsStayOpen-headingTwo'>
                  <button
                    className='accordion-button'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#panelsStayOpen-collapseTwo'
                    aria-expanded='false'
                    aria-controls='panelsStayOpen-collapseTwo'
                  >
                    Features
                  </button>
                </h2>
                <div
                  id='panelsStayOpen-collapseTwo'
                  className='accordion-collapse collapse'
                  aria-labelledby='panelsStayOpen-headingTwo'
                >
                  <div className='accordion-body'>
                    <NewFeatures
                      name={name}
                      setAllFeatures={setAllFeatures}
                      theFeatures={features}
                      productId={productId || pId}
                    />
                  </div>
                </div>
              </div>
              <div className='accordion-item'>
                <h2
                  className='accordion-header'
                  id='panelsStayOpen-headingThree'
                >
                  <button
                    className='accordion-button'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#panelsStayOpen-collapseThree'
                    aria-expanded='false'
                    aria-controls='panelsStayOpen-collapseThree'
                  >
                    Specifications
                  </button>
                </h2>
                <div
                  id='panelsStayOpen-collapseThree'
                  className='accordion-collapse collapse'
                  aria-labelledby='panelsStayOpen-headingThree'
                >
                  <div className='accordion-body'>
                    <NewSpec
                      setSpecifications={setSpecifications}
                      specifications={specifications}
                    />
                  </div>
                </div>
              </div>

              <div className='accordion-item'>
                <h2
                  className='accordion-header'
                  id='panelsStayOpen-headingFour'
                >
                  <button
                    className='accordion-button'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#panelsStayOpen-collapseFour'
                    aria-expanded='false'
                    aria-controls='panelsStayOpen-collapseFour'
                  >
                     Variants &amp; SKUs
                  </button>
                </h2>
                <div
                  id='panelsStayOpen-collapseFour'
                  className='accordion-collapse collapse'
                  aria-labelledby='panelsStayOpen-headingFour'
                >
                  <div className='accordion-body'>
                    <SkuManager
                      variantAxes={variantAxes}
                      setVariantAxes={setVariantAxes}
                      skus={skusData}
                      setSkus={setSkusData}
                      filterAttributes={filterAttributes}
                      setFilterAttributes={setFilterAttributes}
                      pId={pId}
                    />
                  </div>
                </div>
              </div>

            
            </div>
          </div>
        </section>
      </form>
    </>
  )
}
